module.exports = __webpack_public_path__ + "img/emo_19.16c28a9d.png";